import React from "react";
import slicer from "./sclicer";
import createLink from "../createLink";
import {Link} from "react-router-dom";

const mentionDecorator = {
    render : (key, text, data)=>{
        return (
            <Link key={key} to={createLink('userProfile', data.user)} target={"_blank"} rel="noopener noreferrer" className={"mentionned-name"}>
                {data.user.username ? `@${data.user.username}`: text}
            </Link>
        )
    }
}

const linkDecorator = {
    render : (key, text, data)=>{
        return (
            <a key={key} href={data.url} target={data.target || "_blank"} rel={data.rel || ""} className={"linked-name"}>
                {text}
            </a>
        )
    }
}

const extensions = {
    mention : mentionDecorator,
    link : linkDecorator
}
const Reader = ({text = "", meta = {}}) =>{
    let metas = [];
    let metaKeys = Object.keys(meta);
    if (!Array.isArray(metaKeys) || metaKeys.length === 0) return text;
    else {
        metaKeys.forEach(key=>{
            if(Array.isArray(meta[key])){
                let currentMetas = meta[key].map(({offset, length, ...data})=>({
                    type : key,
                    offset,
                    length,
                    data
                }));
                metas.push(...currentMetas);
            }
        });
        let {sliced, hasMetas} = slicer(text, metas);
        if (hasMetas) {
            let children = sliced.map((slice, i)=>{
                return (slice.isMeta && slice.type in extensions) ? extensions[slice.type].render(i, slice.text, slice.data) : slice.text
            });
            return (
                <span children={children}/>
            )
        }
        else return text;
    }
}

export default Reader;